import { render, staticRenderFns } from "./editSupplier.vue?vue&type=template&id=3c906cd0&scoped=true&"
import script from "./editSupplier.vue?vue&type=script&lang=js&"
export * from "./editSupplier.vue?vue&type=script&lang=js&"
import style0 from "./editSupplier.vue?vue&type=style&index=0&id=3c906cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c906cd0",
  null
  
)

export default component.exports